<template>
<button :disabled="disabled" class="z-button" @click="handleClick" :autofocus="autofocus" :type="nativeType" :class="[ type ? 'z-button--' + type : '', size ? 'z-button--' + size : '', { 'is-disabled': disabled, 'is-loading': loading, 'is-plain': plain }]"><i class="z-icon-loading" v-if="loading"></i><i :class="'z-icon-' + icon" v-if="icon && !loading"><svg class="icon icon-error" aria-hidden="true"><use xlink:href="#icon-chenggong"></use></svg></i><span v-if="$slots.default"><slot></slot></span></button>
</template>
<script>
export default {
    name: 'ZButton',
    props: {
      type: {
        type: String,
        default: 'default'
      },
      size: String,
      icon: {
        type: String,
        default: ''
      },
      nativeType: {
        type: String,
        default: 'button'
      },
      loading: Boolean,
      disabled: Boolean,
      plain: Boolean,
      autofocus: Boolean
    },

    methods: {
      handleClick (evt) {
        this.$emit('click', evt)
      }
    }
  }
</script>
<style>
button, input, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
}
.z-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #e5e5e5;
    color: #333;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 8px 15px 9px;
    font-size: 13px;
    border-radius: 2px;
    box-shadow: inset 0 4px 3px rgba(247,247,247,1);
}
.z-button:hover {
    color: #ff7300;
    border-color: #ff7300;
}
.z-button--primary {
  box-shadow: none;
  color: #fff;
  background-color: #ff7300;
  border-color: #ff7300;
}
.z-button--primary:hover {
	color: #fff;
	background-color: #ff7300;
	border-color: #ff7300;
  opacity: 0.7;
}
.z-button--none {
    box-shadow: none;
    color: #1a1a1a;
    background-color:none;
    border:none;
}
.z-button--none:hover {
  color: #1a1a1a;
  background-color: none;
  border-color: none;
  opacity: 0.7;
}

[class*=" z-icon-"], [class^=z-icon-] {
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.z-button.is-disabled, .z-button.is-disabled:focus, .z-button.is-disabled:hover {
    color: #bfcbd9;
    cursor: not-allowed;
    background-image: none;
    background-color: #eef1f6;
    border-color: #d1dbe5;
    opacity: 1;
}
.z-button--submit {
  border-radius: 4px;
  float: right;
  width: 150px;
  height: 50px;
  text-align: center;
  font-size: 20px;
  border: none;
  color: #fff;
  background: #f18e3d;
  cursor: pointer;
  box-shadow: none;
  opacity: 1;
}
.z-button--submit:hover {
  color: #fff;
  background: #fc6621
}
.z-button--skubtn {
    padding: 8px 9px 9px;
    background-color: #f8f8f8;
    font-size: 13px;
    border-radius: 2px;
    vertical-align: middle;
}
.z-button--skubtn:hover {
    color: #333;
    background-color: #f8f8f8;
    border-color: #ccc;
}

.z-button--gray {
  padding: 8px 20px 9px;
  color: #666;
  background: #f7f7f7;
  border: 1px solid #e5e5e5;
  font-size: 13px;
  border-radius: 2px;
  vertical-align: middle;
}
.z-button--gray:hover {
    color: #333;
    background-color: #f8f8f8;
    border-color: #ccc;
}
.z-button--icon-query {
    box-shadow: none;
    color: #fff;
    background-color: #ff7300;
    border-color: #ff7300;
    vertical-align: middle;
}
.z-button--icon-query:hover {
  color: #fff;
  background-color: #ff7300;
  border-color: #ff7300;
  opacity: 0.7;
}
.z-button--blue{
  padding: 7px 20px 8px;
  box-shadow: none;
  color: #fff;
  background-color: #007cb9;
  border-color: #007cb9;
  vertical-align: middle; 
}
.z-button--blue:hover {
  color: #fff;
  background-color: #007cb9;
  border-color: #007cb9;
  opacity: 0.7;
}
</style>